export default "__VITE_ASSET__UZM2Irnv__"